import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { AppTemplateDirective } from './template.directive';
import { CdkDropListActualContainerDirective } from './cdk-drop-list-actual-container.directive';

@NgModule({
  imports: [CommonModule, NgxMaskDirective, NgxMaskPipe],
  declarations: [AppTemplateDirective, CdkDropListActualContainerDirective],
  exports: [AppTemplateDirective],
})
export class AppDirectiveModule {}
